module.exports = __webpack_public_path__ + "static/media/level1.fea86f67.svg";